import { Component, Input } from '@angular/core';

@Component({
    selector: 'gh-snippet-hero',
    templateUrl: 'snippet-hero.component.html',
    standalone: false
})

export class SnippetHeroComponent {
  @Input() articles: any;
}
